export const addSlashToEndOfUrl = (url: string) => (url.endsWith('/') ? url : url + '/');
